module.exports = __webpack_public_path__ + "img/[右哼哼].8c94b505.svg";